import { MomentService } from 'src/app/vehicles/services/moment.service';
import {
  ParamsGetFramesFromHistory,
  RequestGetFramesFromHistory,
} from '../../../models/manager-content-vehicle-history-drawer.model';
import * as moment from 'moment';

export function adaptParamsGetFramesFromHistory(
  params: ParamsGetFramesFromHistory,
  momentService: MomentService
): RequestGetFramesFromHistory {
  const user_id = localStorage.getItem('user_id');
  const vehicle = {
    imei: params.unit.GNSSIMEI,
    name: params.unit.unitName,
  };

  const start_date = adaptDateForParamsGetFramesFromHistory(
    params.start_date,
    params.time_start
  );
  const end_date = adaptDateForParamsGetFramesFromHistory(
    params.end_date,
    params.time_end
  );

  return {
    fecha_desde: start_date,
    fecha_hasta: end_date,
    tzCustom: momentService.tzCustom ?? '- 5 hour',
    tzOffset: momentService.tzOffset ?? '-05:00',
    tzPHP: momentService.tzPHP ?? ' +5 hours',
    user_id: user_id || '',
    vehiculos: JSON.stringify([vehicle]),
  };
}

// Devuelve un string con formato: YYYY-MM-DDTHH:mm:00-05:00
// - date: fecha (Date|string) aceptando formatos comunes
// - time: 'HH:mm' o 'HH:mm:ss' (si es inválida, se usa 00:00:00)
const DEFAULT_TZ_OFFSET = '-05:00';
export function adaptDateForParamsGetFramesFromHistory(
  date: string | Date,
  time: string
): string {
  const dateMoment = moment(date);
  if (!dateMoment.isValid()) return '';

  const timeMoment = moment(time, ['HH:mm:ss', 'HH:mm'], true);
  const timePart = timeMoment.isValid()
    ? timeMoment.format('HH:mm:00')
    : '00:00:00';

  const timezone = moment.tz.guess();

  return moment.tz(
    `${dateMoment.format('YYYY-MM-DD')}T${timePart}`,
    timezone
  ).format('YYYY-MM-DDTHH:mm:ssZ');
}
